import React from 'react';
import {SectionMain, Tabs, Tab, FormDialog} from 'components/core';
import Singletons from 'controllers/Singletons';
import {ProceduresCtxProvider} from 'components/dataProviders/procedures';
import ProceduresPanel from './main/panel';
import ProceduresMain from './main/index';
import {ProcedureFilesProvider} from 'components/dataProviders/procedures';
import {ProcedureStepsCtxProvider} from 'components/dataProviders/procedureSteps';
import {TemplatesCtxProvider} from 'components/dataProviders/procedureTemplates';

export default function ProceduresWrapper()
{
  return <ProceduresCtxProvider><Procedures></Procedures></ProceduresCtxProvider>
}


function Procedures()
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [panelState, setPanelState] = React.useState({show: false, props: {}, selectedID: null});
    const [createDialogOpen, setCreateDialogOpen] = React.useState(false);
    // const [loadedProcedure, setLoadedProcedure] = React.useState(null);

    const editable = Singletons.currentUser.profiles.indexOf("experts") > -1 || Singletons.currentUser.profiles.indexOf("administrators") > -1;

    const tabButtonLabels = [
      "Crear Procedimiento"
    ];

    const handleNewButtonClick = () =>
    {
      setCreateDialogOpen(true);
    }

    // const handleTabChange = (index) =>
    // {
    //   if(index !== selectedTab)
    //   {
    //     setShowPanel(false);
    //     setPanelProps(null);
    //     setSelectedTab(index);
    //   }
    // }

    const handleClosePanel = () =>
    {
        setPanelState({show: false, props: {}, selectedID: null});
    }

    const handleShowPanel = (panelProps) =>
    {
      // setLoadedProcedure(panelProps.procedureID);
      setPanelState({show: true, props: panelProps, selectedID: panelProps.procedureID});
    }

    // const tabs = <Tabs value={selectedTab} onChange={(evt, index) => handleTabChange(index)} textColor="primary" indicatorColor="primary">
    //     <Tab label="Procedimientos"/>
    // </Tabs>
    const tabs = null;

    const panels = [
      <ProceduresPanel {...panelState.props} onClose={() => handleClosePanel()} editable={editable}/>
    ];

    

    return <>
    <ProcedureStepsCtxProvider procedureID={panelState.selectedID}>
      <ProcedureFilesProvider procedureID={panelState.selectedID}>
        <TemplatesCtxProvider>
        <SectionMain title="Procedimientos" buttonLabel={tabButtonLabels[selectedTab]} tabs={tabs} showDetail={panelState.show} onButtonClick={() => handleNewButtonClick()} detail = {panels[selectedTab]} buttonHidden={!editable}>
          <ProceduresMain mainDialogOpen={createDialogOpen} handleDialogClose={()=>setCreateDialogOpen(false)} collapsed = {panelState.show} handleShowPanel={(props) => handleShowPanel(props)}/>
        </SectionMain>
        </TemplatesCtxProvider>
      </ProcedureFilesProvider>
    </ProcedureStepsCtxProvider>
    </>
}

